import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
    searchArea: {
        padding: '10px 10px 0px 10px',
        display: 'flex',
        flexDirection: 'column',
        position: 'sticky',
        top: 0,
        zIndex: 999,
        boxSizing: 'border-box',
        background: 'white',
        width: '100%',
    },
});
